export default __webpack_public_path__ + "static/media/zoo_mapa.56139a85.svg";